import "./StatCard.css";
import EChartsSparkline from "../../Charts/EChartsSparkline";

export default function StatCard({ title, count, icon, color = "#9247e3", sparkData }) {
  return (
    <div className="card card-side-border h-100" style={{ "--stat-card-accent": color }}>
      <div className="card-body stat-card-body">
        <div className="d-flex align-items-center gap-2">
          {icon && (
            <div className="stat-card-icon rounded-circle d-flex align-items-center justify-content-center" style={{ backgroundColor: `${color}20`, color }}>
              {icon}
            </div>
          )}
          <div className="d-flex flex-column">
            <p className="stat-card-title m-0">{title}</p>
            <p className="stat-card-count m-0" style={{ color }}>{count}</p>
          </div>
        </div>
        {sparkData && sparkData.length > 1 && (
          <div className="stat-card-sparkline">
            {sparkData && <EChartsSparkline data={sparkData} color={color} />}
          </div>
        )}
      </div>
    </div>
  );
}
